import { differenceInHours, format } from 'date-fns';
import { AxiosError } from 'axios';

export const FULL_HISTORY_EXPORT_STARTED_MESSAGE =
  'Your export has started. A CSV containing all historic data will arrive in your inbox.';

export const CERTIFIED_PDF_EXPORT_STARTED_MESSAGE =
  'Your export has started. A Certified PDF containing your selected data will arrive in your inbox.';

export const DATE_RANGE_CSV_DOWNLOADED_MESSAGE =
  'Your audit trail CSV has been downloaded successfully. Check your Downloads folder.';

/**
 * Maps full-history and locked-PDF enqueue failures to the same toast copy.
 * 409 with a startedAt older than 5h is treated as a stuck row.
 */
export function getAuditExportErrorToastMessage(error: AxiosError<{ startedAt?: string }> | undefined): string {
  const status = error?.response?.status;
  if (status === 409) {
    const startedAtRaw = error?.response?.data?.startedAt;
    const startedAt = startedAtRaw ? new Date(startedAtRaw) : null;
    const isStuck = !!startedAt && !isNaN(startedAt.getTime()) && differenceInHours(new Date(), startedAt) >= 5;
    return isStuck
      ? `Your export started at ${format(startedAt!, 'MMM d, yyyy h:mm a')} and may need support — please reach out.`
      : "Your export is already in progress. We'll email you when it's ready.";
  }
  if (status === 429) {
    return "You've requested too many exports recently. Please try again later.";
  }
  if (status === 503) {
    return "Couldn't start your export — please try again in a moment.";
  }
  return 'Something went wrong. Please try again.';
}
